<section *ngIf="!!post" class="max-w-[600px] mx-auto">
  <div class="h-[64px] px-[24px] pt-[8px]">
    <div class="h-[48px] flex items-center justify-between">
      <h5 class="about__title">{{post.title}}</h5>
      <button
        id="btnClose"
        (click)="goBack()"
        type="button"
        class="w-[48px] h-[48px] bg-white/75 border-[2px] border-white rounded-full flex items-center justify-center backdrop-blur-[16px] fixed z-50 md:sticky md:ml-auto! top-[16px] right-[24px]"
      >
        <svg
          class="w-6 h-6"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18 17.94 6M18 18 6.06 6"
          />
        </svg>
      </button>
    </div>
  </div>
  <img [src]="`${post.cover?.image?.file?.url}`" [alt]="post.title" class="mb-[16px] px-[16px] rounded-[8px]" />
  <app-post-content-section
    [postContent]="post"
    [hideTitle]="true"
    [copyLink]="`${config.baseUrl}/about`"
  ></app-post-content-section>
</section>
